import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface AdminCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  path?: string;
  onClick?: () => void;
  color: string;
}

export function AdminCard({ title, description, icon, path, color, onClick }: AdminCardProps) {
  const content = (
    <div className={`p-6 rounded-xl border border-gray-200 hover:border-accent-green transition-all group relative overflow-hidden`}>
      <div className="flex items-center space-x-4">
        <div className={`p-3 rounded-xl ${color} group-hover:scale-110 transition-transform`}>
          {icon}
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-black group-hover:text-black">
            {title}
          </h2>
          <p className="text-sm text-black mt-1 group-hover:text-black">{description}</p>
        </div>
        <ArrowRight className="h-5 w-5 text-black group-hover:text-black group-hover:translate-x-1 transition-all" />
      </div>
    </div>
  );

  return (
    path ? (
      <Link to={path}>{content}</Link>
    ) : onClick ? (
      <button onClick={onClick} className="w-full text-left">{content}</button>
    ) : content
  );
}